import { api } from '@/lib/api';

export const patientsService = {
  async getAll() {
    const { data } = await api.get('/patients');
    return { data };
  },

  async getById(id) {
    const { data } = await api.get(`/patients/${id}`);
    return { data };
  },

  async create(patientData) {
    const { data } = await api.post('/patients', patientData);
    return { data };
  },

  async update(id, patientData) {
    const { data } = await api.patch(`/patients/${id}`, patientData);
    return { data };
  },

  async delete(id) {
    await api.delete(`/patients/${id}`);
    return { success: true };
  },
};
